<template>
  <GridPage
    title="Merchants"
    :subtitle="editMerchantID"
    viewset="/shop/admin/merchants/"
    :actions="actions"
    :fields="fields"
    :showAddButton="true"
    :refresh="refresh"
    @addButton="handleAddButton"
    @rowAction="handleRowAction"
  >
    <template v-slot:modals>
      <EditModal
        :editMerchantID="editMerchantID"
        @close="handleCloseEditModal"
        @dataUpdated="handleDataUpdated"
      />
      <!-- <DisableModal
        :merchantID="disableMerchantID"
        @close="handleCloseDeleteModal"
        @dataUpdated="handleDataUpdated"
      /> -->
      <AddModal
        :show-modal="showAddModal"
        @close="handleCloseAddModal"
        @dataUpdated="handleDataUpdated"
      />
    </template>
  </GridPage>
</template>

<script>
import GridPage from "@/components/layout/Page/GridPage.vue";
import formatters from "@/components/DataGrid/formatters";

import EditModal from "./EditModal";
import AddModal from "./AddModal";
// import DisableModal from "./DisableModal";

export default {
  data() {
    return {
      showAddModal: false,
      editMerchantID: null,
      disableMerchantID: null,
      enabledFilterOptions: [
        { name: "", title: "Show All" },
        { name: "1", title: "Enabled Only" },
        { name: "0", title: "Disabled Only" }
      ],
      enabledFilter: "",
      refresh: 0,
      actions: [
        {
          name: "Edit",
          icon: "edit",
          event: "edit"
        },
        {
          name: "Disabled",
          icon: "close",
          theme: "danger",
          event: "delete",
          condition(rowData) {
            return !rowData.system_default;
          }
        }
      ],
      fields: [
        {
          name: "id",
          title: "ID",
          sortField: "id",
          visible: false
        },
               {
          name: "name",
          title: "Name",
          visible: true
        },
        {
          name: "num_orders",
          title: "Num Orders",
          visible: true
        },
        {
          name: "num_products",
          title: "Num Products",
          visible: true
        },

      ]
    };
  },
  computed: {},
  methods: {
    handleRowAction(data) {
      if (data.action.event === "edit") {
        this.editMerchantID = data.props.rowData.id;
      }
      if (data.action.event === "disable") {
        this.disableMerchantID = data.props.rowData.id;
      }
    },
    handleCloseEditModal(event) {
      this.editMerchantID = null;
    },
    handleAddButton(event) {
      this.showAddModal = true;
    },
    handleCloseAddModal(event) {
      this.showAddModal = false;
    },
    handleCloseDeleteModal(event) {
      this.deletePK = null;
    },
    handleDataUpdated(event) {
      this.refresh = this.refresh + 1;
    }
  },
  components: {
    GridPage,
    EditModal,
    AddModal,
    // DisableModal
  },
  beforeCreate() {
    // this.$store.dispatch("productCategories/init");
  }
};
</script>

<style></style>
